import '../styles/equipment.css'
function Equipment() {
    return (
        <div className="equipment">
            <div className="equipment-heading">
                <h2> HISTOLOGY AND PATHOLOGY EQUIPMENT </h2>
                <p> Specialized Service for All Major Brands </p>
                <p> DC Biomedical Services, LLC in Streamwood, IL is a service company providing superior repair and maintenance for histology and pathology equipment.  
                    We are the chosen service provider for hospitals, laboratories, and research facilities in the US, and primarily in the Midwest.  
                    Our  skills and experience in handling core histology equipment and other biomedical devices from all major brands make us stand out in the industry. 
                    We also buy your used equipment!</p>
            </div>
            <div className="equipment-content">
                <div className="equipment-item"> 
                    <h4>Tissue Processors</h4>
                    <ul className="equipment-list">
                        <li>Sakura VIP K</li>
                        <li>Sakura VIP 2000 & 3000</li>
                        <li>Sakura VIP E</li>
                        <li>Sakura VIP 5</li>
                        <li>Sakura VIP 6</li>
                        <li>Leica Peloris</li>
                        <li>Leica ASP 300</li>
                    </ul>
                </div>
                <div className="equipment-item">
                    <h4>Cover Slippers</h4>
                    <ul className="equipment-list">
                        <li>Sakura 4740</li>
                        <li>Sakura G2 6500</li>
                        <li>Sakura 6400</li>
                        <li>Leica CV 5030</li>
                    </ul>
                </div>
                <div className="equipment-item"> 
                    <h4>Stainers</h4>
                    <ul className="equipment-list">
                        <li>Sakura Prisma 6130</li>
                        <li>Sakura DRS 601</li>
                        <li>Sakura 2000</li>
                        <li>Thermo XY</li>
                        <li>Thermo Linstainers</li>
                        <li>Leica Autostainer XL</li>
                    </ul>
                </div>
                <div className="equipment-item"> 
                    <h4>Microtomes</h4>
                    <ul className="equipment-list">
                        <li>Sakura Accu-Cut SRM 200</li>
                        <li>Microm HM Series</li>
                        <li>Shandon Finesse</li>
                        <li>Shandon ME</li>
                        <li>Shandon 325</li>
                        <li>Leica RM Series</li>
                    </ul>
                </div>
                <div className="equipment-item"> 
                    <h4>Cryostats</h4>
                    <ul className="equipment-list">
                        <li>Sakura Tissue Tek Cryo3 & Cryo3+</li>
                        <li>Thermo FE Cryotome</li>
                        <li>Thermo FSE Cryotome</li>
                        <li>Thermo 620 Cryotome</li>
                        <li>Microm HM Models</li>
                        <li>Microm NX50/NX70</li>
                        <li>Leica CM Models</li>
                    </ul>
                </div>
                <div className="equipment-item">
                    <h4>Slide/Cassette Labelers</h4>
                    <ul className="equipment-list">
                        <li>Sakura Autowrite Cassette/Slide Printers</li>
                        <li>Thermo Slidemate</li>
                        <li>Thermo Printmate</li>
                        <li>Thermo & TBS Microwriters</li>
                        <li>Leica IPS Slide Printer</li>
                        <li>Leica IPC Cassette Printer</li>
                    </ul>
                </div>
                <div className="equipment-item">
                    <h4>Misc. Equipment</h4>
                    <ul className="equipment-list">
                        <li>Grossing Centers</li>
                        <li>Water Baths</li>
                        <li>Centrifuges</li>
                    </ul>
                </div>
            </div>
            <div className="equipment-footer">
                <h2> Choose From Our Full Service, PM Only, or Billable Plans.</h2>
                <p> For all your needs in lab equipment repair and maintenance, trust DC Biomedical Services, LLC. 
                    We have full service plans that suit your budget and requirements. 
                    Call us or send us a message to learn more about what we offer.</p>
            </div>
        </div>
    );
}

export default Equipment;
